'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { FeatureTriplet } from '../../components/site/feature-triplet'
import { Reveal } from '../../components/site/reveal'
import { SectionHead } from '../../components/site/section-head'
import { SiteSection } from '../../components/site/section'

/** 台灣團隊開發：三件只有在地團隊做得到的事。 */
export function DictationFeaturesSection() {
  const { t } = useTranslation(['web'])

  return (
    <SiteSection trackingKey="features">
      <Reveal>
        <SectionHead
          eyebrow={t('web:dictationPage.features.eyebrow')}
          titleKey="web:dictationPage.features.title"
        />
      </Reveal>
      <Reveal className="mt-(--gap-xl)">
        <FeatureTriplet
          items={[
            {
              title: t('web:dictationPage.features.taiwaneseTitle'),
              description: t('web:dictationPage.features.taiwaneseDesc'),
            },
            {
              title: t('web:dictationPage.features.invoiceTitle'),
              description: t('web:dictationPage.features.invoiceDesc'),
            },
            {
              title: t('web:dictationPage.features.dictionaryTitle'),
              description: t('web:dictationPage.features.dictionaryDesc'),
            },
          ]}
        />
      </Reveal>
    </SiteSection>
  )
}
